import { createAuthClient } from "better-auth/react";
import {
  adminClient,
  organizationClient,
  twoFactorClient,
} from "better-auth/client/plugins";
import { stripeClient } from "@better-auth/stripe/client";
import { passkeyClient } from "@better-auth/passkey/client";

export const authClient = createAuthClient({
  plugins: [
    adminClient(),
    organizationClient(),
    stripeClient({
      subscription: true, // Enable subscription management
    }),
    passkeyClient(),
    twoFactorClient({
      onTwoFactorRedirect() {
        // Detect locale from current URL (localePrefix: "as-needed", default "fr")
        const isEn = window.location.pathname.startsWith("/en/");
        const prefix = isEn ? "/en" : "";
        // Preserve redirect param from login
        const params = new URLSearchParams(window.location.search);
        const redirect = params.get("redirect");
        const qs = redirect ? `?redirect=${encodeURIComponent(redirect)}` : "";
        window.location.href = `${prefix}/auth/two-factor${qs}`;
      },
    }),
  ],
});

// Export only the base methods that we know exist
export const { signIn, signOut, signUp, useSession } = authClient;

// Organization and admin functionality is accessed via authClient.organization and authClient.admin
// Subscription functionality is accessed via authClient.subscription
// Two-factor functionality is accessed via authClient.twoFactor
